import {
  parseQuery,
  DefaultQueryParams,
  environmentBuilder,
  GameLiveConnection,
} from '@pascal/pascal-core';

import { gameService } from './GameService';
import { gameName, socketGamePath } from '../enums/gameConfigsAndUrls';

export class GameConnection extends GameLiveConnection {
  constructor(url) {
    super(url);
  }

  async sendGameGetInitialState(isFirst = true) {
    const {
      [DefaultQueryParams.GameTypeId]: gameTypeId,
      [DefaultQueryParams.PartnerId]: partnerId,
      [DefaultQueryParams.GameId]: gameId,
    } = parseQuery(window.location.search);

    super.onGetInitialStateResult(this.handleInitialResult);

    await super.sendGetInitialState({ partnerId, gameTypeId, gameId });

    if (isFirst) {
      this.executeGameConnections();
      this.executeGlobalConnections();
    }
  }

  handleInitialResult(data) {
    gameService.onGetInitialStateResult.call(gameService, data);
  }

  // onDemoBetResult(handler) {
  //   super.on('DoDemoBetResult', handler);
  // }

  onLiveBetsResult(handler) {
    super.on('LiveBetsResult', handler);
  }

  // doDemoBet(amount, odd) {
  //   super.invoke('DoDemoBet', amount, odd);
  // }

  executeGameConnections() {
    // this.onDemoBetResult(gameService.handleDoDemoBetResult.bind(gameService));
    this.onLiveBetsResult(gameService.handleLiveBetsResult.bind(gameService));
    super.onDoBetResult(gameService.handleDoBetResult.bind(gameService));
    super.onDoBetResultValidation(gameService.handleDoBetResultValidation.bind(gameService));
  }

  executeGlobalConnections() {
    super.onFreeBetEnded();
    super.onFreeBetAwarded();
    super.onGetBalanceResult();
    super.onMaintenanceNotify();
    super.onFreeBetCountUpdate();
    super.onGameOpen(gameService.handleGameOpen.bind(gameService));
    super.onClose(gameService.handleConnectionError.bind(gameService));
    super.onReconnected(gameService.handleReconnected.bind(gameService));
    super.onReconnecting(gameService.handleReconnecting.bind(gameService));
  }
}

const { socketUrl } = environmentBuilder(gameName);

const url = (path) => ({ url: `${socketUrl}${path}` });

export const gameLiveConnection = new GameConnection(url(socketGamePath));
